import { Avatar, CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  blackBackArrowImage,
  dateIconImage,
  editWhiteImage,
  roadIconImage,
  timeIconImage,
  truckIconImage,
} from "../../../assets";
import { invokeApi, S3baseUrl } from "../../../bl_libs/ApiCalling";
import AddressCard from "./components/Address-Card/AddressCard";
import Items from "./components/Items/Items";
import ExtraItems from "./components/Extra-Items/ExtraItems";
import UserCard from "./components/User-Card/UserCard";
import {
  getStatusForCustomer,
  time_convert,
} from "../../../ui_libs/Functions/functions";
import Comments from "./components/Comments/Comments";
import { Alert } from "@material-ui/lab";
import EditRequest from "./components/Edit-Request/EditRequest";
import Request from "./components/Request/Request";
import CompanyNotes from "./components/Company-Notes/CompanyNotes";
import ClientComment from "./components/Client-Comment/ClientComment";

function RequestDetails(props) {
  const [requestData, setRequestData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [errMessage, setErrMessage] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [selected, setSelected] = useState("");
  const [popup, setPopup] = useState(false);

  const handleModel = (address) => {
    console.log(address, "handleModel");
    setErrMessage("");
    setPopup(false);
    setSelected(address);
    setTimeout(() => {
      setPopup(true);
      document.getElementById("model-div").click();
    }, 200);
  };

  const closeModel = () => {
    if (document.getElementById("close-delete-address")) {
      document.getElementById("close-delete-address").click();
    }
  };
  const DeleteAddress = () => {
    if (request_address.length < 3) {
      return setErrMessage(
        "Minimum two address is required. If you want to change please edit your address or add new address then delete this."
      );
    }

    const editAddressUrl = requestData.request.request_type
      ? "/app_api/delete_address"
      : "/api/customer/delete_address";

    let requestObj = {
      path: editAddressUrl,
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.id}`,
      address_id: `${selected.id}`,
    };
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        closeModel();
        fetchRequestDetails();
      } else {
        setErrMessage(res.message);
      }
    });
  };

  const fetchRequestDetails = () => {
    //move back if state is undefined

    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/detail_request/${props.match.params.id}`,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setRequestData(res.request_detail);
        setIsLoading(false);
      } else {
        alert(res.message);
      }
    });
  };

  useEffect(() => {
    fetchRequestDetails();
  }, []);

  if (isLoading) {
    return (
      <section className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request DETAIL</span>
          </p>
          <div className="container-fluid">
            <div className="Circular-Progress">
              <CircularProgress />
            </div>
            {errMessage && (
              <div className="Circular-Progress">
                Error Message: {errMessage}
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }

  console.log(requestData, "REQUEST DATA");

  const {
    request_address,
    request,
    get_request_item,
    get_extra_request_item,
    full_access_link,
  } = requestData;
  const requestExtraItems = requestData.get_extra_request_item.filter(item=>item.quantity>0);
  console.log(requestExtraItems,"requestExtraItems")
  const {
    s_time,
    s_date,
    net_distance,
    move_type,
    final_comment,
    company_notes,
    id,
    request_timeline_status,
    final_amount,
    discount,
    customer_budget,
    request_type,
    total_discount,
  } = request;

  return (
    <>
      <section id="" className="content-wrapper rating-page">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <p className="small-text-bold page-title ">
              <img
                className="pointer-point"
                src={blackBackArrowImage}
                onClick={() => props.history.goBack()}
              />
              <span>Request DETAIL</span>
            </p>
            {full_access_link !== "" && (
              <a href={full_access_link} target="_blank">
                <p>
                  <strong>
                    <u>Act as Customer</u>
                  </strong>
                </p>
              </a>
            )}
          </div>

          <div className="rating-wrapper mt-40 mt-m-30">
            <div className="row">
              <div className="col-md-6 col-12 col-lg-4">
                <Request
                  requestData={requestData}
                  fetchRequestDetails={fetchRequestDetails}
                  setIsLoadingPage={setIsLoading}
                  setIsEdit={setIsEdit}
                />
                {isEdit && (
                  <EditRequest
                    requestData={requestData}
                    fetchRequestDetails={fetchRequestDetails}
                    setIsLoadingPage={setIsLoading}
                    setIsEdit={setIsEdit}
                  />
                )}

                <div className="rounded-box mt-4">
                  <div className="heading-wrapper black-bg text-center">
                    <h6 className="text-white">Customer</h6>
                  </div>
                  <UserCard requestData={requestData} type="customer" />
                </div>
                <div className="rounded-box mt-4">
                  <div className="heading-wrapper black-bg text-center">
                    <h6 className="text-white">Company</h6>
                  </div>
                  <UserCard requestData={requestData} type="company" />
                </div>

                <div className="rounded-box mt-4">
                  <div className="heading-wrapper black-bg text-center">
                    <h6 className="text-white">Foreman</h6>
                  </div>
                  <UserCard requestData={requestData} type="foreman" />
                </div>

                {/* <Timeline requestData={requestData} /> */}
              </div>
              <div className="col-md-6 col-12 mt-sm-30 col-lg-8">
                <div className="rounded-box">
                  <div className="heading-wrapper black-bg text-center position-relative">
                    <h6 className="text-white">Request Information</h6>
                  </div>
                  <div className="request-info p-3 pt-4">
                    <div className="row req-date-time-info no-gutters pb-sm-4">
                      <div className="col-6 col-lg-3 req-date-time-info-box">
                        <div className="row no-gutters small-font-size">
                          <div className="col-2">
                            <img src={dateIconImage} />
                          </div>
                          <div className="col-10 pl-1 pl-sm-0 pr-1 req-info-text">
                            {s_date}
                          </div>
                        </div>
                      </div>
                      <div className="col-6 col-lg-3 req-date-time-info-box small-font-size">
                        <div className="row no-gutters">
                          <div className="col-2">
                            <img src={timeIconImage} />
                          </div>
                          <div className="col-10 pl-1 pl-sm-0 pr-1 req-info-text">
                            {/* {`${time_convert(s_time.slice(0,5))} to ${time_convert(s_time.slice(8,13))}`} */}
                            {s_time &&
                              s_time !== "8AM - 12PM Morning" &&
                              s_time !== "12PM - 5PM Evening" &&
                              s_time !== "Entire day" &&
                              `${time_convert(
                                s_time.split("-")[0].trim()
                              )} to ${time_convert(
                                s_time.split("-")[1].trim()
                              )}`}
                            {s_time &&
                              (s_time == "8AM - 12PM Morning" ||
                                s_time == "12PM - 5PM Evening" ||
                                s_time == "Entire day") &&
                              `${s_time}`}
                          </div>
                        </div>
                      </div>
                      <div className="col-6 col-lg-3 req-date-time-info-box small-font-size">
                        <div className="row no-gutters">
                          <div className="col-2">
                            <img src={roadIconImage} />
                          </div>
                          <div className="col-10 pl-1 pl-sm-0 pr-1 req-info-text">
                            {net_distance} miles
                          </div>
                        </div>
                      </div>
                      <div className="col-6 col-lg-3 req-date-time-info-box small-font-size">
                        <div className="row no-gutters">
                          <div className="col-2">
                            <img src={truckIconImage} />
                          </div>
                          <div className="col-10 pl-1 pl-sm-0 pr-1 req-info-text">
                            {move_type}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="req-addresses-wrapper row mt-4">
                      {request_address.map((address, i) => (
                        <AddressCard
                          key={i}
                          index={i}
                          address={address}
                          request_id={id}
                          handleModel={handleModel}
                          request_timeline_status={request_timeline_status}
                          request_type={request_type}
                        />
                      ))}
                    </div>
                    <div className="row mt-2 pb-2">
                      <div className="col-12 justify-content-center d-flex">
                        <button
                          className="custom-btn-small custom-buton"
                          onClick={() =>
                            props.history.push(
                              "/admin/request/add-address/" + id
                            )
                          }
                        >
                          Add new
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="items-info-wrapper mt-2">
                    <div className="info-header text-center">
                      <h6 className="black-color">
                        Items({get_request_item.length})
                      </h6>
                    </div>
                    <Items request_item={get_request_item} />
                  </div>
                  <div className="items-info-wrapper mt-2">
                    <div className="info-header text-center">
                      <h6 className="black-color">
                        Extra Items({requestExtraItems.length})
                      </h6>
                    </div>
                    <ExtraItems extra_request_items={get_extra_request_item} />
                  </div>
                  <div className="items-info-wrapper mt-2">
                    <div className="info-header text-center">
                      <h6 className="black-color">Client Comment</h6>
                    </div>
                    <ClientComment
                      request={request}
                      final_comment={final_comment}
                      fetchRequestDetails={fetchRequestDetails}
                    />
                  </div>

                  <div className="items-info-wrapper mt-2">
                    <div className="info-header text-center">
                      <h6 className="black-color">Company Notes</h6>
                    </div>
                    <CompanyNotes
                      request={request}
                      final_comment={company_notes}
                      fetchRequestDetails={fetchRequestDetails}
                    />
                  </div>
                </div>
                <Comments
                  requestData={requestData}
                  fetchRequestDetails={fetchRequestDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        data-toggle="modal"
        data-target="#delete-address"
        id="model-div"
      ></div>
      <div
        className="modal fade"
        id="delete-address"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="logout-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            {errMessage && (
              <Alert variant="filled" severity="error">
                {errMessage}
              </Alert>
            )}
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-delete-address"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {popup && (
              <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
                <div className="modal-body p-0">
                  <h5 className="text-center" id="logout-title">
                    Delete Address
                  </h5>

                  <p className="text-center sub-title pb-2 mb-1 pt-4">
                    Are your sure you want to delete this address?
                  </p>
                  <div className="text-center pb-4">
                    <span className="black-color text-center ">
                      "{selected.complete_address}"
                    </span>
                  </div>
                  <div className="row justify-content-center text-center">
                    <div className="col-6">
                      <button
                        onClick={DeleteAddress}
                        className="custom-btn-small custom-buton float-right"
                      >
                        Yes
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        data-dismiss="modal"
                        aria-label="Close"
                        className="custom-btn-small custom-buton custom-button-pink float-left"
                        // onClick={closeModel}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default RequestDetails;
